import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import { toUrl } from '../lib/config';

const IstenmeyenOlayPage: React.FC = () => {
  const [formData, setFormData] = useState({
    olayGerceklesti: 'Gerçekleşti',
    ramakKaldi: '',
    olayinKonusu: 'Hasta Güvenliği',
    digerBelirtiniz: '',
    gizlilikTalebi: 'Var',
    olayAnlatiniz: '',
    olayaIliskinVarsaGorus: '',
    hukukiYansimasi: 'Yok'
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      setError('');
      setSuccess(false);

      const url = toUrl('/api/istenmeyen-olay');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Form gönderilemedi. Lütfen tekrar deneyin.');
      }

      setSuccess(true);
      setFormData({
        olayGerceklesti: 'Gerçekleşti',
        ramakKaldi: '',
        olayinKonusu: 'Hasta Güvenliği',
        digerBelirtiniz: '',
        gizlilikTalebi: 'Var',
        olayAnlatiniz: '',
        olayaIliskinVarsaGorus: '',
        hukukiYansimasi: 'Yok'
      });

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err: any) {
      setError(err.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="anket-page">
      <Container className="py-5">
        <div className="text-center mb-5">
          <h6 className="text-muted mb-2">Bize ulaşın</h6>
          <h1 className="mb-3">
            İletişim
          </h1>
          <div style={{ 
            width: '60px', 
            height: '3px', 
            backgroundColor: '#f44336', 
            margin: '0 auto 20px' 
          }}></div>
          <p className="text-muted mb-3" style={{ maxWidth: '600px', margin: '0 auto 15px' }}>
            Megapark Hastanesi her an ve her zaman sizin yanınızda
          </p>
          <div style={{ 
            width: '100%', 
            height: '1px', 
            backgroundColor: '#ddd', 
            margin: '0' 
          }}></div>
        </div>

        <div className="mt-5">
          <h4 className="mb-2 fw-bold">İstenmeyen Olay Bildirim Formu</h4>
          <div style={{ 
            width: '60px', 
            height: '3px', 
            backgroundColor: '#f44336', 
            marginBottom: '30px' 
          }}></div>

          {/* Başarı Mesajı */}
          {success && (
            <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
              <Alert.Heading>Teşekkür Ederiz!</Alert.Heading>
              <p>
                İstenmeyen olay bildiriminiz başarıyla gönderildi. Bildiriminiz değerlendirilecektir.
              </p>
            </Alert>
          )}

          {/* Hata Mesajı */}
          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible>
              <Alert.Heading>Hata!</Alert.Heading>
              <p>{error}</p>
            </Alert>
          )}

          <Form onSubmit={handleSubmit} className="survey-form">
            {/* Olay Gerçekleşti / Ramak Kaldı Radio Buttons */}
            <Form.Group className="mb-4">
              <div className="mb-3">
                <Form.Check
                  type="radio"
                  id="olayGerceklesti"
                  name="olayGerceklesti"
                  label="Olay Gerçekleşti"
                  value="gerceklesti"
                  checked={formData.olayGerceklesti === 'gerceklesti'}
                  onChange={handleChange}
                  className="mb-2"
                />
                <Form.Check
                  type="radio"
                  id="ramakKaldi"
                  name="olayGerceklesti"
                  label="Ramak Kaldı"
                  value="ramak"
                  checked={formData.olayGerceklesti === 'ramak'}
                  onChange={handleChange}
                />
              </div>
            </Form.Group>

            {/* Olayın Konusu */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Olayın Konusu
              </Form.Label>
              <Form.Select
                name="olayinKonusu"
                value={formData.olayinKonusu}
                onChange={handleChange}
                required
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              >
                <option value="">Hasta Güvenliği</option>
                <option value="calisan-guvenlik">Çalışan Güvenliği</option>
                <option value="ziyaretci-guvenlik">Ziyaretçi Güvenliği</option>
                <option value="diger">Diğer</option>
              </Form.Select>
            </Form.Group>

            {/* Diğer İse Belirtiniz */}
            <Form.Group className="mb-4">
              <Form.Control
                type="text"
                name="digerBelirtiniz"
                value={formData.digerBelirtiniz}
                onChange={handleChange}
                placeholder="Diğer İse Belirtiniz..."
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Gizlilik Talebi */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Gizlilik Talebi
              </Form.Label>
              <Form.Select
                name="gizlilikTalebi"
                value={formData.gizlilikTalebi}
                onChange={handleChange}
                required
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              >
                <option value="">Gizlilik Talebi Var</option>
                <option value="yok">Gizlilik Talebi Yok</option>
              </Form.Select>
            </Form.Group>

            {/* Olay Anlatınız */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Olay Anlatınız
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="olayAnlatiniz"
                value={formData.olayAnlatiniz}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Olaya İlişkin Varsa Görüş ve Öneriler */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Olaya İlişkin Varsa Görüş ve Öneriler
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={6}
                name="olayaIliskinVarsaGorus"
                value={formData.olayaIliskinVarsaGorus}
                onChange={handleChange}
                placeholder=""
                className="form-control-lg"
                style={{ backgroundColor: '#f5f5f5' }}
              />
            </Form.Group>

            {/* Hukuki Yansıması Olay / Hukuki Yansıması Olay Radio Buttons */}
            <Form.Group className="mb-4">
              <div className="mb-3">
                <Form.Check
                  type="radio"
                  id="hukukiYansimasiVar"
                  name="hukukiYansimasi"
                  label="Hukuki Yansıması Var"
                  value="Var"
                  checked={formData.hukukiYansimasi === 'Var'}
                  onChange={handleChange}
                  className="mb-2"
                />
                <Form.Check
                  type="radio"
                  id="hukukiYansimasiYok"
                  name="hukukiYansimasi"
                  label="Hukuki Yansıması Yok"
                  value="Yok"
                  checked={formData.hukukiYansimasi === 'Yok'}
                  onChange={handleChange}
                />
              </div>
            </Form.Group>

            {/* Submit Button */}
            <div className="mt-4">
              <Button
                type="button"
                size="lg"
                disabled={loading}
                onClick={(e) => {
                  handleSubmit(e as any);
                }}
                style={{
                  backgroundColor: '#4CAF50',
                  borderColor: '#4CAF50',
                  fontWeight: '600',
                  padding: '12px 40px',
                  borderRadius: '25px'
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Gönderiliyor...
                  </>
                ) : (
                  'Gönder'
                )}
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    </div>
  );
};

export default IstenmeyenOlayPage;
